import { apiGet } from '../api/client';

/**
 * Download stored LV PDF for a saved property (server reads Supabase Storage).
 * @param {() => Promise<string>} getToken
 * @param {{ kod_ku: string, cislo_lv: string, user_id?: string|null }} params
 * @returns {Promise<{ pdfBase64: string, pdfName: string }>}
 */
export async function fetchStoredLvPdf(getToken, { kod_ku, cislo_lv, user_id: userId }) {
  const k = encodeURIComponent(String(kod_ku || '').trim());
  const l = encodeURIComponent(String(cislo_lv || '').trim());
  const u =
    userId != null && String(userId).trim()
      ? `&user_id=${encodeURIComponent(String(userId).trim())}`
      : '';
  const res = await apiGet(`/api/property-lv-pdf?KodKU=${k}&CisloLv=${l}${u}`, getToken);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Failed to load stored LV PDF.');
  }
  return {
    pdfBase64: String(data.pdfBase64 || ''),
    pdfName: String(data.pdfName || 'LV.pdf'),
  };
}
